
// disable "import/no-extraneous-dependencies", seems like eslint can't find @babel/polyfill
// eslint-disable-next-line
// import 'babel-polyfill';

// eslint-disable-next-line
import 'sass/index.scss';

import App from 'App';

import renderApp from './lib/renderApp';

require('lib/icons');

// import App from './boilerplate/App';

renderApp.withoutAuth(App);
